import React, { Component } from "react";
import { Link } from "react-router-dom";
import calcularPx from "../calcularPx.js";
import { ReactComponent as IcoChevron } from "../../../res/iconos/chevron.svg";
import SubmenuProductos from "./submenuProductos.jsx";
import { createRef } from "react";
import { CSSTransition } from "react-transition-group";
import AccesoDesktop from "../acceso/menuAccesoDesktop.jsx";
import AccesoMobile from "../acceso/menuAccesoMobile.jsx";
import { ReactComponent as IcoAcceso } from "../../../res/iconos/acceso.svg";
import RegionMobile from "../acceso/menuRegionMobile.jsx";
import RegionDesktop from "../acceso/menuRegionDesktop.jsx";

class Menu extends Component {
  state = { mostrarSubmenuProductos: false, mostrarSubmenuAcceso: false, mostrarSubmenuRegion: false, nivelLogin: this.props.nivelLogin };

  //constructor, componentDidMount, componentWillUnmount y handleClickOutside son para ocultar el submenu de productos tocando fuera de el
  constructor(props) {
    super(props);
    this.ref1 = createRef();
    this.ref2 = createRef();
    this.ref3 = createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener("click", this.handleClickOutside, true);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.nivelLogin != this.props.nivelLogin) {
      this.setState({ nivelLogin: this.props.nivelLogin });
    }
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside, true);
  }

  handleClickOutside(event) {
    if (this.ref1.current && !this.ref1.current.contains(event.target))
      this.setState({ mostrarSubmenuProductos: false });
    if (this.ref2.current && !this.ref2.current.contains(event.target))
      this.setState({ mostrarSubmenuAcceso: false });
    if (this.ref3.current && !this.ref2.current.contains(event.target))
      this.setState({ mostrarSubmenuRegion: false });
  }

  style() {
    let style = {
      background: "transparent",
      border: "none",
    };
    if (this.props.mobile) {
      style.position = "relative";
      style.display = "block";
      style.width = "100%";
      style.padding = calcularPx(30) + " " + calcularPx(0);
      style.textAlign = "left";
    } else {
      style.position = "relative";
      style.height =  "100%";
      style.alignContent = "center";
      style.alignSelf = "center";
      style.textAlign = "center";
    }
    return style;
  }

  render() {
    const { botones, mobile, ocultar, setRegion, region } = this.props;

    return (
      <nav
        style={{
          display: mobile ? undefined : "flex",
          flexGrow: 1,
          justifySelf: mobile?undefined:"right",
          justifyContent: mobile?undefined:"right",
          gap: 55,
          justifyItems: mobile?undefined:"center",
          backgroundColor: mobile?"#5b5d61":"transparent",
          paddingLeft: mobile?"5%":"5%",
          paddingRight: mobile?"5%":"5%",
          height: mobile ? "100vh" : "100%",
          width: "100%",
        }}
      >
        {
        region == 'ar' ?
        <div ref={this.ref1}>
          <button
            className={"itemNavBar"}
            style={this.style()}
            onClick={() => {
              this.setState({ mostrarSubmenuProductos: !this.state.mostrarSubmenuProductos });
            }}
            onMouseEnter={
              mobile
                ? null
                : () => {
                    this.setState({ mostrarSubmenuProductos: true });
                  }
            }
            onMouseLeave={
              mobile
                ? null
                : () => {
                    this.setState({ mostrarSubmenuProductos: false });
                  }
            }
          >
            Productos
            <CSSTransition
              in={this.state.mostrarSubmenuProductos}
              timeout={250}
              classNames="girar"
            >
              <IcoChevron
                width={calcularPx(20)}
                height={calcularPx(20)}
                style={{
                  position: mobile ? "absolute" : "static",
                  left: "95%",
                }}
              />
            </CSSTransition>
            <CSSTransition
              in={this.state.mostrarSubmenuProductos}
              timeout={250}
              classNames="submenu"
              unmountOnExit
            >
              <SubmenuProductos mobile={mobile} ocultarMenu={ocultar} />
            </CSSTransition>
          </button>
        </div>
        :
        <Link
          className={"itemNavBar"}
          onClick={ocultar}
          to={"/"+region+"/productos"}
          style={this.style()}
        >
          Productos
        </Link>
        }
        {region == 'ar' &&
        <>
        
        <Link
          className={"itemNavBar"}
          onClick={ocultar}
          to="/puntosDeVenta"
          style={this.style()}
        >
          Puntos de venta
        </Link>
        
        <Link
          className={"itemNavBar"}
          onClick={ocultar}
          to="/posventa"
          style={this.style()}
        >
          Posventa
        </Link>
        <Link
          className={"itemNavBar"}
          onClick={ocultar}
          to="/preguntasFrecuentes"
          style={this.style()}
        >
          Preguntas Frecuentes
        </Link>
        </>
        }
        <Link
          className={"itemNavBar"}
          onClick={ocultar}
          to={(region!='ar' && region != 'int')?("/"+region+"/contacto"):"/contacto"}
          style={this.style()}
        >
          Contacto
        </Link>
        {this.state.nivelLogin === 3 ? (
          <Link
            className={"itemNavBar"}
            onClick={ocultar}
            to="/registrarProducto"
            style={this.style()}
          >
            Registre su producto
          </Link>
        ) : (
          <></>
        )}

        { region == 'ar' &&
        (mobile ? (
          <AccesoMobile
            nivelLogin={this.state.nivelLogin}
            botones={botones}
            ocultar={ocultar}
          />
        ) : (
          <div ref={this.ref2}>
          <button
            className={"itemNavBar"}
            style={this.style()}
            onClick={() => {
              this.setState({ mostrarSubmenuAcceso: !this.state.mostrarSubmenuAcceso });
            }}
            onMouseEnter={
              mobile
                ? null
                : () => {
                    this.setState({ mostrarSubmenuAcceso: true });
                  }
            }
            onMouseLeave={
              mobile
                ? null
                : () => {
                    this.setState({ mostrarSubmenuAcceso: false });
                  }
            }
          >
            <IcoAcceso
              width={25}
              height={25}
              style={{
                position: "relative",
                display: "inline",
              }}
            />
            <CSSTransition
              in={this.state.mostrarSubmenuAcceso}
              timeout={250}
              classNames="submenu"
              unmountOnExit
            >
              <AccesoDesktop
                nivelLogin={this.state.nivelLogin}
                botones={botones}
                ocultar={ocultar}
              />
            </CSSTransition>
          </button>
        </div>
        ))
        }

        {mobile ? (
          <RegionMobile
            ocultar={ocultar}
            setRegion={setRegion}
          />
        ) : (
          <div ref={this.ref3}>
          <button
            className={"itemNavBar"}
            style={this.style()}
            onClick={() => {
              this.setState({ mostrarSubmenuRegion: !this.state.mostrarSubmenuRegion });
            }}
            onMouseEnter={
              mobile
                ? null
                : () => {
                    this.setState({ mostrarSubmenuRegion: true });
                  }
            }
            onMouseLeave={
              mobile
                ? null
                : () => {
                    this.setState({ mostrarSubmenuRegion: false });
                  }
            }
          >
            <img 
              src={require(`../../../res/iconos/region_${this.props.icono}.png`)} 
              style={{
                height: 25,
                position: "relative",
                display: "inline",
              }}
            />
            <CSSTransition
              in={this.state.mostrarSubmenuRegion}
              timeout={250}
              classNames="submenu"
              unmountOnExit
            >
              <RegionDesktop
                setRegion={setRegion}
                ocultar={ocultar}
              />
            </CSSTransition>
          </button>
        </div>
        )}
      </nav>
    );
  }
}

/*
<Link
  className={"itemNavBar"}
  onClick={ocultar}
  to="/servicioTecnico"
  style={this.style("64.06%")}
>
  SERVICIO TÉCNICO
</Link>
        */

export default Menu;
